/*

class to generate evidence

http://www.hl7.org/fhir/condition-definitions.html#Condition.evidence

{
  "code" : [{ code }], // C? Manifestation/symptom
  "detail" : [{ Reference(Any) }] // C? Supporting information found elsewhere
},

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  code: Joi.array().items(codeSchema).required(),
  detail: Joi.array().items( Joi.string().optional() ).optional(),
};

// Define class
class Evidence {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Evidence = Evidence;
exports.evidenceSchema = schema;